module.exports = __webpack_public_path__ + "static/media/canais-7.08ca2103.jpg";